import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=0e22a785&scoped=true"
import script from "./Approval.vue?vue&type=script&lang=js"
export * from "./Approval.vue?vue&type=script&lang=js"
import style0 from "./Approval.vue?vue&type=style&index=0&id=0e22a785&lang=scss"
import style1 from "./Approval.vue?vue&type=style&index=1&id=0e22a785&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e22a785",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e22a785')) {
      api.createRecord('0e22a785', component.options)
    } else {
      api.reload('0e22a785', component.options)
    }
    module.hot.accept("./Approval.vue?vue&type=template&id=0e22a785&scoped=true", function () {
      api.rerender('0e22a785', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/Approval.vue"
export default component.exports